// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__392kP","load2":"Spinner_load2__1hen6"};